<footer class="footer mt-auto">
    <span *ngIf="version">v{{version}}</span>
    <span class="float-end">Copyright ©{{year}} <a href="https://handheld.ie/">Handheld Technologies Ltd</a></span>
</footer>
